export const PERMISSION_PAGE = {
  NOT_FOUND: {
    TH: 'คุณไม่มีสิทธิ์เข้าถึงหน้านี้!',
    EN: 'Don\'t have permission of page!'
  }
}

export const TOOLTIP_USER = {
  PERMISSION_DELETE: {
    TH: 'คุณไม่สามารถลบแอดมินสูงสุดของระบบได้',
    EN: 'You can\'t delete default admin of system.'
  }
}

export const TOOLTIP_PERMISSION = {
  TH: 'คุณไม่มีสิทธิ์ในการเข้าถึงส่วนนี้',
  EN: 'You don\'t have permission.'
}

export const PERMISSION_LOGIN = {
  TH: 'บัญชีของคุณไม่ได้รับอนุญาต',
  EN: 'Your account don\'t have permission.'
}
